import React from "react";
import { CheckIcon } from "lucide-react";

import ScrollToTop from "../../../components/utils/ScrollToTop";
import { Tray, TrayCell, TrayCells, TrayHeader } from "../../../probate/components/tray";
import { Empty, EmptyDescription } from "../../../probate/components/ui/empty";
import { getFormattedDate } from "../../../utils/textUtils";
import { useSelectedCase } from "../utils/hooks";
import { doableHref, formDoableTypes } from "./doableLinks";
import { isCompletedTask } from "./ProbateMessages";
import ProbatePage from "./ProbatePage";

const CompletedCells = ({ doables }) => (
  <TrayCells>
    {doables.map((doable) => (
      <TrayCell
        key={doable.id}
        icon={<CheckIcon aria-hidden />}
        title={doable.title}
        status="Completed"
        details={doable.completed_at && getFormattedDate(doable.completed_at)}
        complete
        // A client app form, such as an identity check, has no page to go back to
        href={formDoableTypes.includes(doable.doable_type) ? doableHref(doable) : undefined}
      />
    ))}
  </TrayCells>
);

const ProbateCaseArchive = () => {
  const selectedCase = useSelectedCase({ caseScreen: "archive" });

  if (!selectedCase) {
    return null;
  }

  const completed = selectedCase.doables.filter(isCompletedTask);
  const otherThings = completed.filter((d) => d.doable_type === "emailed_request");
  const forms = completed.filter((d) => d.doable_type !== "emailed_request");

  return (
    <ProbatePage caseRef={selectedCase.case_reference} title="Everything you’ve done">
      <ScrollToTop />
      {completed.length === 0 && (
        <Empty>
          <EmptyDescription>Nothing completed yet</EmptyDescription>
        </Empty>
      )}
      {forms.length > 0 && (
        // No TrayHeader, so Tray's aria-labelledby would name the region after nothing
        <Tray aria-labelledby={undefined}>
          <CompletedCells doables={forms} />
        </Tray>
      )}
      {otherThings.length > 0 && (
        <Tray variant="muted">
          <TrayHeader title="Completed other things" />
          <CompletedCells doables={otherThings} />
        </Tray>
      )}
    </ProbatePage>
  );
};

export default ProbateCaseArchive;
